import { render, staticRenderFns } from "./MemberConfig.vue?vue&type=template&id=0c744080&scoped=true&"
import script from "./MemberConfig.vue?vue&type=script&lang=js&"
export * from "./MemberConfig.vue?vue&type=script&lang=js&"
import style0 from "./MemberConfig.vue?vue&type=style&index=0&id=0c744080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c744080",
  null
  
)

export default component.exports